module.exports = __webpack_public_path__ + "static/media/7S.3687b706.svg";